'use client';

import { Suspense, useEffect, useState, type FC } from 'react';

import ProductRating from '@hyex/modules/shared/Product/common/ProductRating';

import type { Testimonial } from '@hyex/dxp/types/store/Testimonials';

import ProductReview from './product-review';
import ArrowCarousel from '@hyex/modules/shared/Carousels/ArrowCarousel';

export type DisplayedTestimonial = Pick<
  Testimonial,
  'firstName' | 'lastName' | 'photo' | 'disabled' | 'rating'
> & {
  moreInfo: {
    improvements: string;
    display: string;
    dateSubmitted: string;
  };
};

type Props = {
  testimonials: DisplayedTestimonial[];
  pageMode?: boolean;
  productName?: string;
  withHeader?: boolean;
};

const ProductReviews: FC<Props> = ({
  testimonials,
  pageMode = false,
  productName,
  withHeader = true,
}) => {
  const slides = () =>
    testimonials?.map((testimonial, i) => {
      return (
        <ProductReview
          feedback={testimonial.moreInfo?.display ?? testimonial.moreInfo.improvements}
          author={`${testimonial.firstName} ${testimonial.lastName[0]}.`}
          image={testimonial.photo}
          rating={testimonial.rating}
          key={i}
        />
      );
    });

  return (
    <section className="product-reviews">
      <div className="container">
        {withHeader && (
          <div className="reviews-title">
            <h2>{productName} Customer Reviews</h2>
          </div>
        )}

        {pageMode ? (
          <>
            {testimonials?.map((testimonial, i) => {
              return (
                <div className="testimonials-page-mode" key={i}>
                  <div className="header">
                    <span className="name">
                      {testimonial.firstName} {testimonial.lastName[0]}.
                    </span>
                    {testimonial.rating && <ProductRating rating={testimonial.rating} />}
                    <p className="date">{testimonial.moreInfo.dateSubmitted}</p>
                  </div>
                  <div className="details">
                    <span className="testimonial-product-name">On {productName}</span>
                    <p className="improvements">{testimonial.moreInfo.display}</p>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <ArrowCarousel slides={slides} alwaysShowArrows={true} options={{}} />
        )}
      </div>
    </section>
  );
};

export default ProductReviews;
